import {ChangeDetectionStrategy, Component, Inject} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {GoogleDriveFil, GoogleDriveFilvelgerGui} from "./GoogleDriveFilvelgerGui";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatDialogTitle} from "@angular/material/dialog";
import {TranslateModule} from "@ngx-translate/core";
import {AgendaelementId, ImporterGoogleDokumentISakSpesifikasjon, MøteId} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {GoogleDriveOpplasting} from "./GoogleDriveOpplasting";
import {OpplastingsstatusSkyfilerKomponent} from "web-ng2/delt/komponenter/filvelger-skytjenester/komponenter/opplastingsstatus-skyfiler/opplastingsstatus-skyfiler";
import {EksisterendeDokumentFunksjon, ValgteSkyfiler} from "web-ng2/delt/komponenter/filvelger-skytjenester/SkyfilOpplasting";
import {BasisFilvelgerDialog, DialogParametre} from "web-ng2/delt/komponenter/filvelger-skytjenester/modale/BasisFilvelgerDialog";

const debug = initDebugger('GoogleDriveFilvelgerDialogKomponent');

/**
 * Modal dialog som lar bruker velge filer fra google drive og registrere disse som saksdokumenter under angitt sak.
 * Merk at i motsetning til i {@link OnedriveFilvelgerDialogKomponent} vises ikke google drive picker gui i en iframe
 * plassert i GoogleDriveFilvelgerDialogKomponent sin html, men i en iframe som opprettes av google drive filpicker biblioteket.
 * Å instruere google drive picker biblioteket til å tegne seg ut i en annen iframe er mulig men krever en del kode, har her valgt
 * den enkleste fremgangsmåte som er å la google drive picker gui håndtere iframen fult og helt selv.
 * Av denne grunn vises ikke modalen til GoogleDriveFilvelgerDialogKomponent før filepicker guien returnerer valgte filer.
 */
@Component({
    selector: 'googledrive-filvelger-dialog',
    templateUrl: 'googledrive-filvelger-dialog.html',
    styleUrl: 'googledrive-filvelger-dialog.scss',
    imports: [
        MatDialogTitle,
        TranslateModule,
        OpplastingsstatusSkyfilerKomponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GoogleDriveFilvelgerDialogKomponent extends BasisFilvelgerDialog<GoogleDriveFil, ImporterGoogleDokumentISakSpesifikasjon> {

    static vis(dialog: MatDialog, sakId: AgendaelementId, møteId: MøteId, eksisterendeDokument: EksisterendeDokumentFunksjon): MatDialogRef<GoogleDriveFilvelgerDialogKomponent, void> {
        return dialog.open(GoogleDriveFilvelgerDialogKomponent, {data: {sakId, møteId, eksisterendeDokument} as DialogParametre, width: '50%', height: '500px', panelClass: 'googledrive-filepicker-dialog'});
    }

    constructor(@Inject(MAT_DIALOG_DATA) parametre: DialogParametre,
                dialogRef: MatDialogRef<GoogleDriveFilvelgerDialogKomponent>,
                private googleDriveFilvelgerGui: GoogleDriveFilvelgerGui,
                googleDriveOpplasting: GoogleDriveOpplasting) {
        super(parametre, dialogRef, googleDriveOpplasting, debug);
    }

    // BasisFilvelgerDialog implementasjon

    protected velgFiler(): Promise<ValgteSkyfiler<GoogleDriveFil> | null> {
        return this.googleDriveFilvelgerGui.visPickerGUI();
    }
}
